module.exports = __webpack_public_path__ + "img/river.be5030ca.webp";